import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useDeviceType } from '../../hooks/useDeviceType';
import { MobileShell } from '../mobile/MobileShell';

export default function Layout() {
  const location = useLocation();
  const { loading } = useAuth();
  const { isMobile, isTablet } = useDeviceType();

  if (loading) {
    // Detect theme based on current URL - same logic as LoadingScreen
    let background = 'var(--app-bg)';
    let textColor = 'var(--text-color)';

    try {
      const pathname = location.pathname;

      // Check currentPageTheme first
      const currentPageTheme = sessionStorage.getItem('currentPageTheme');
      if (currentPageTheme) {
        const parsed = JSON.parse(currentPageTheme);
        if (parsed.colors) {
          background = `linear-gradient(135deg, ${parsed.colors.primaryColor}, ${parsed.colors.secondaryColor})`;
          textColor = parsed.colors.textColor || '#ffffff';
        }
      } else {
        // Fallback: check specific theme caches based on URL

        // Profile pages: /u/:username or /user/:username
        if (pathname.startsWith('/u/') || pathname.startsWith('/user/') || pathname.startsWith('/profile/')) {
          const keys = Object.keys(sessionStorage);
          const profileThemeKey = keys.find(key => key.startsWith('profileTheme_'));
          if (profileThemeKey) {
            const cached = sessionStorage.getItem(profileThemeKey);
            if (cached) {
              const parsed = JSON.parse(cached);
              background = `linear-gradient(135deg, ${parsed.primaryColor}, ${parsed.secondaryColor || parsed.primaryColor})`;
              textColor = parsed.textColor || '#ffffff';
            }
          }
        }

        // Community pages: /community/:slug
        else if (pathname.startsWith('/community/')) {
          const keys = Object.keys(sessionStorage);
          const communityThemeKey = keys.find(key => key.startsWith('communityTheme_'));
          if (communityThemeKey) {
            const cached = sessionStorage.getItem(communityThemeKey);
            if (cached) {
              const parsed = JSON.parse(cached);
              background = `linear-gradient(135deg, ${parsed.primaryColor}, ${parsed.secondaryColor || parsed.primaryColor})`;
              textColor = parsed.textColor || '#ffffff';
            }
          }
        }
      }
    } catch (e) {
      console.warn('[Layout] Failed to detect theme:', e);
    }

    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background, color: textColor, transition: 'none' }}>
        <div className="text-xl" style={{ transition: 'none' }}>Loading...</div>
      </div>
    );
  }

  // ── Mobile / tablet → full mobile shell with swipeable sections ──
  // The MobileShell manages its own navigation (5 sections, 3 sub-panels each).
  // It does NOT use React Router Outlet — it renders section content directly.
  if (isMobile || isTablet) {
    return <MobileShell />;
  }

  // ── Desktop → existing page-per-route layout ──
  return (
    <div className="min-h-screen" style={{ background: 'var(--app-bg)' }}>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
